/**
 * @file The start year of the fiscal year containing `now`, read in the
 * calendar's `timeZone` the way the analytics service resolves its year to
 * date: a local month at or after `fiscalYearStartMonth` belongs to this
 * year's fiscal year, an earlier one to last year's. Consumers: the Settings →
 * Analytics Goals section and the Overview. Returns `null` when `timeZone` is
 * not a valid IANA zone, so callers can show the calendar as unset.
 */
import { DateTime } from 'luxon';

import type { AnalyticsCalendar } from '#types';

export const analyticsFiscalStartYear = (
  calendar: Pick<AnalyticsCalendar, 'timeZone' | 'fiscalYearStartMonth'>,
  now: Date,
): number | null => {
  const local = DateTime.fromJSDate(now, { zone: calendar.timeZone });
  if (!local.isValid) return null;
  return local.month >= calendar.fiscalYearStartMonth
    ? local.year
    : local.year - 1;
};
